(function () {
  class GrefiProductRelated extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-grefi-pr-track]');
      if (track && track.children.length > 0) {
        this.#initCarousel();
        return;
      }
      this.#loadRecommendations();
    }

  #initCarousel() {
    const wrap = this.querySelector('.grefi-bs__carousel');
    if (!wrap || wrap.dataset.grefiInit) return;
    wrap.dataset.grefiInit = 'true';

    const track = wrap.querySelector('.grefi-bs__track');
    const prev = wrap.querySelector('.grefi-bs__arrow--prev');
    const next = wrap.querySelector('.grefi-bs__arrow--next');
    if (!track || !prev || !next) return;

    const scroll = (dir) => {
      const amount = track.clientWidth * 0.85;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));
  }

  async #loadRecommendations() {
    const url = this.dataset.url;
    if (!url) return;

    this.classList.add('is-loading');

    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error('fetch failed');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newTrack = doc.querySelector('[data-grefi-pr-track]');
      const track = this.querySelector('[data-grefi-pr-track]');

      if (newTrack && track && newTrack.children.length > 0) {
        track.innerHTML = newTrack.innerHTML;
        this.#initCarousel();
      } else {
        this.classList.add('is-empty');
      }
    } catch {
      if (!this.querySelector('[data-grefi-pr-track]')?.children.length) {
        this.classList.add('is-empty');
      }
    } finally {
      this.classList.remove('is-loading');
    }
  }
  }

  if (!customElements.get('grefi-product-related')) {
    customElements.define('grefi-product-related', GrefiProductRelated);
  }
})();
